import "@babel/polyfill";
import "@/utils/extend";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "@/store";
import "@/styles/index.scss";
import "./icons"; // icon
import ElementUI from "element-ui";
import VueAMap from "vue-amap";
import htmlToPdf from "@/utils/PDF";
import "@/utils/smooth-scroll";
import { Storage } from "@/utils/storage";
import configJson from "@/config";
import defaultAvatar from "@/assets/avatar.png";
import { routeInterceptor } from "@/utils/interceptor";

import {
  showConfirm,
  showSuccess,
  showError,
  showInvalidMessage,
  disabledFutureDate,
  disabledPastDate,
  getSelectionText,
  formatDate,
  isNull,
  isEmpty,
  deepClone,
  forObj,
  own,
  imageWatermark,
  time,
  format
} from "@/utils";
import navigateTo from "@/utils/navigate";
import "./filter";
import "./directive";
import VueParticles from "vue-particles";
import ErrorImg from "@/assets/error.png";
import FEmpty from "@/components/empty";
import FPagination from "@/components/pagination";
import FLazyComponent from "@/components/lazyComponent";
import * as calc from "./utils/calc";

// 取消浏览器中的Vue警告
Vue.config.silent = true;

Vue.prototype.$time = time;
Vue.prototype.$Storage = Storage;
Vue.prototype.$showInvalidMessage = showInvalidMessage;
Vue.prototype.$showConfirm = showConfirm;
Vue.prototype.$showError = showError;
Vue.prototype.$showSuccess = showSuccess;
Vue.prototype.$disabledFutureDate = disabledFutureDate;
Vue.prototype.$disabledPastDate = disabledPastDate;
Vue.prototype.$getSelectionText = getSelectionText;
Vue.prototype.$navigateTo = navigateTo;
Vue.prototype.$errorImg = ErrorImg;
Vue.prototype.$formatDate = formatDate;
Vue.prototype.$isNull = isNull;
Vue.prototype.$isEmpty = isEmpty;
Vue.prototype.$deepClone = deepClone;
Vue.prototype.$forObj = forObj;
Vue.prototype.$own = own;
Vue.prototype.$formRules = configJson.rules;
Vue.prototype.$calc = calc;
Vue.prototype.$imgWm = imageWatermark;
Vue.prototype.$format = format;
Vue.config.productionTip = false;
Vue.prototype.$OSS_URL = "https://cdnoss.fangmao.com";

//全局方法
const globalMount = Vue => {
  Vue.mixin({
    computed: {
      $userInfo() {
        return this.$store.state.settings.userInfo;
      },
      $defaultAvatar() {
        return defaultAvatar;
      }
    }
  });
};
Vue.use(globalMount);
Vue.use(ElementUI);
Vue.use(VueParticles);
Vue.use(htmlToPdf);

Vue.component("f-empty", FEmpty);
Vue.component("f-pagination", FPagination);
Vue.component("f-lazy-component", FLazyComponent);

/**
  本地开发环境默认使用的是本地菜单（全部菜单）
  如需使用线上配置的菜单（根据角色权限返回）该配置设为false即可
  测试接口时 返回的是测试环境菜单 生产接口时返回的是成产环境接口菜单
  ps: 这个变量只在getMenuListByUser这个接口成功返回数据时生效，所以设置后需刷新或重新登录
 **/
window.USE_LOCAL_MENUS = true;

// 解决amap刷新报错
setTimeout(() => {
  localStorage.removeItem("_AMap_raster");
  Vue.use(VueAMap);
}, 0);

// 初始化vue-amap
VueAMap.initAMapApiLoader({
  // 高德的key
  key: "9c2563745618d38053dad78bfb27dab6",
  // 插件集合
  plugin: [
    "AMap.Autocomplete",
    "AMap.PlaceSearch",
    "AMap.Scale",
    "AMap.OverView",
    "AMap.ToolBar",
    "AMap.MapType",
    "AMap.PolyEditor",
    "AMap.CircleEditor",
    "AMap.Geocoder"
  ],
  // 高德 sdk 版本，默认为 1.4.4
  v: "1.4.4"
});

routeInterceptor();

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
